exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vsg_split-grid[data-v-a4677a68]{display:grid;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
